/**
 * exports HTTP status codes
 */

export default {
  ABORTED: 0,
  NO_CONTENT: 204,
  OK: 200,
};



// WEBPACK FOOTER //
// ./lib/utils/http_status.js